import { emailRegex, HelpTypes, phonePatternRegex } from '@pharmaplan/common';
import * as Yup from 'yup';

import strings from '../../../../localization';
import { nameRegex, postalCodeRegExp } from '../../../../helpers/Constants';
import { LeadCreationMethod } from './helper';

const isEmailCreation = (creationMethod: LeadCreationMethod) =>
  creationMethod === LeadCreationMethod.email;

const validator = () =>
  Yup.object().shape({
    creationMethod: Yup.string().required(strings.requiredField),
    name: Yup.string().when('creationMethod', {
      is: isEmailCreation,
      then: () =>
        Yup.string()
          .required(strings.requiredField)
          .matches(nameRegex, strings.pleaseEnterValidName),
    }),
    email: Yup.string().when('creationMethod', {
      is: isEmailCreation,
      then: () =>
        Yup.string()
          .trim()
          .matches(emailRegex, strings.emailValid)
          .required(strings.requiredField),
    }),
    campaignId: Yup.string().required(strings.requiredField),
    userType: Yup.string().required(strings.requiredField),
    phone: Yup.string().when('creationMethod', {
      is: isEmailCreation,
      then: () =>
        Yup.string()
          .matches(
            phonePatternRegex,
            `${strings.wrongFormat} : ###-###-####`,
          ),
    }),
    postalCode: Yup.string().nullable().when(
      ['userType', 'creationMethod'],
      {
        is: (userType: string, creationMethod: LeadCreationMethod) =>
          userType === HelpTypes.pharmacy && isEmailCreation(creationMethod),
        then: () =>
          Yup.string()
            .required(strings.requiredField)
            .matches(postalCodeRegExp, strings.postalCodeValidation),
      },
    ),
    broadcastGroupId: Yup.string().when('creationMethod', {
      is: (creationMethod: LeadCreationMethod) =>
        creationMethod === LeadCreationMethod.broadcastGroup,
      then: () =>
        Yup.string().required(strings.requiredField),
    }),
    emails: Yup.array().of(Yup.string()).when('creationMethod', {
      is: (creationMethod: LeadCreationMethod) =>
        creationMethod === LeadCreationMethod.broadcastGroup,
      then: () =>
        Yup.array()
          .of(Yup.string())
          .min(1, strings.requiredField),
    }),
    removedEmails: Yup.array().of(Yup.string()),
    notes: Yup.string().nullable(),
  });

export default validator;
